import { Controller, ColorFrom, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/table/border-color/config';
import { Form, ColorOperations } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { getDrawerColorOptions, getRgbaColor } from '@framework/workbench/drawer/utils/color-options';
import { ITableBorderColorFeature } from './table-border-color-interface';
import { rgb2Hex } from '@src/slide/infrastructure/module/independent/color/transform';

@Controller({ formItems: FORM_CONFIGS })
export class TableBorderColorController {
    constructor(@Loader(ITableBorderColorFeature) private loader: IDynamicLoader<ITableBorderColorFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.TABLE_BORDER_COLOR, 'content')
    public getColorSelectButton(): JSX.Element {
        return this.feature.getColorSelectButton();
    }
}
